export default (input: string | number) =>
  typeof input === "string" ? parseInt(input, 10) : input;
